import { NaturalPersonFormValues } from 'features/new-actor/types/naturalPersonFormValues';
import { InputsConfig } from 'types/form/inputsConfig';
import { addressInputsConfig } from './addressInputsConfig';
import { personalInformationInputsConfig } from './personalInformationInputsConfig';


type NaturalInputsConfig = InputsConfig<Exclude<keyof NaturalPersonFormValues,'id'>>

export const naturalPersonInputsConfig: NaturalInputsConfig = {
  ...personalInformationInputsConfig,
  ...addressInputsConfig,
};
